// extracted by mini-css-extract-plugin
export default {"TertiaryButton":"TertiaryButton__TertiaryButton___Jk9ZN","disabled":"TertiaryButton__disabled___SvtEt","error":"TertiaryButton__error___lJ_zN"};